export const isNonNegativeNumber = (value?: number | null): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value >= 0;
